import {
  IProviderMock,
  mockTravelService,
  mockCurrencyService,
  mockServiceService,
  mockInfoService,
  mockCustomerService,
  mockPlatformService,
  mockRequestService,
  mockPaymentService,
  mockPromoCodeService
} from './index'

export const mockProvider = (): IProviderMock => ({
  travel: mockTravelService(),
  currency: mockCurrencyService(),
  service: mockServiceService(),
  info: mockInfoService(),
  customer: mockCustomerService(),
  platform: mockPlatformService(),
  request: mockRequestService(),
  payment: mockPaymentService(),
  promo: mockPromoCodeService()
})
